export enum MolSearchBoxEnum {
  NORMAL = "normal",
  SMALL = "small",
}
